export default __webpack_public_path__ + "static/media/icon_info_on.b263b2fc.svg";